import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HolidaysService {

  public REST_API_SERVER:string = `${environment.REST_API_URL}/api/web/${environment.version}`;

  
  constructor(private http:HttpClient) { }

  public getHolidays(filterParams:any = {}):Observable<any>{
    return this.http.get(`${this.REST_API_SERVER}/holidays`,{params:filterParams,observe:'response'});
  }

  public createHoliday(data:any):Observable<any>{
    return this.http.post(`${this.REST_API_SERVER}/holidays/create`,data);
  }
}